/**
 * ActiveGameExistsScreen.tsx
 * Active game conflict screen
 */

import { type FC } from 'react';

import { Button } from '@skillarea/lib-frontend';
import { Title, TextBlock } from '@skillarea/lib-frontend';
import { useTranslation } from 'react-i18next';

import styles from '../MatchmakingModal.module.scss';

export interface IActiveGameExistsScreenProps {
  onGoToActiveGame: () => void;
  onBack: () => void;
}

export const ActiveGameExistsScreen: FC<IActiveGameExistsScreenProps> = ({
  onBack,
  onGoToActiveGame,
}) => {
  const { t } = useTranslation('matchmaking');

  return (
    <div className={styles.screen} data-testid="matchmaking-active-game">
      <div className={`${styles.centered} ${styles.resultScreen}`}>
        <div className={styles.resultIcon}>
          <span className={styles.emoji}>!</span>
        </div>

        <TextBlock className={styles.resultText} size="l">
          {t('activeGame.message')}
        </TextBlock>

        <Title className={styles.resultTitle} color="contrast" variant="benzin">
          {t('activeGame.title')}
        </Title>
      </div>

      <div className={styles.footer}>
        <div className={styles.actionButtons}>
          <Button
            className={styles.acceptButton}
            color="accent"
            name={t('activeGame.goToGame')}
            onClick={onGoToActiveGame}
            size="s"
            variant="filled"
          >
            {t('activeGame.goToGame')}
          </Button>
          <Button
            className={styles.declineButton}
            color="primary"
            name={t('common.back')}
            onClick={onBack}
            size="s"
            variant="filled"
          >
            {t('common.back')}
          </Button>
        </div>
      </div>
    </div>
  );
};
